import React from 'react';
import { CTAButton } from './CTAButton';
import { Shield, BookOpen, Headphones, Gift } from 'lucide-react';
export function PricingSection() {
  return <section className="bg-gray-100 py-16 px-4" data-id="element-284">
      <div className="max-w-xl mx-auto" data-id="element-285">
        <div className="bg-white rounded-2xl border-2 border-patriot-red shadow-2xl overflow-hidden relative" data-id="element-286">
          <div className="absolute top-0 inset-x-0 bg-patriot-red text-white text-xs font-bold text-center py-1.5 uppercase tracking-wide" data-id="element-287">
            Best Value — Limited Time Offer
          </div>

          <div className="bg-red-50 py-5 px-6 border-b border-red-100 mt-7" data-id="element-288">
            <h3 className="text-2xl font-bold text-navy text-center" data-id="element-289">
              Charlie Kirk Collector Bundle
            </h3>
            <p className="text-center text-gray-500 text-sm mt-1" data-id="element-290">
              Instant digital delivery — no shipping required
            </p>
          </div>

          <div className="p-8 flex flex-col items-center" data-id="element-291">
            <div className="mb-6 text-center" data-id="element-292">
              <span className="text-gray-400 line-through text-lg" data-id="element-293">$95.94</span>
              <div className="text-5xl font-bold text-patriot-red mt-1" data-id="element-294">
                $17
                <span className="text-base font-normal text-gray-500 ml-1" data-id="element-295">
                  USD
                </span>
              </div>
              <p className="text-green-600 font-bold text-sm mt-2" data-id="element-296">
                You save $78.94!
              </p>
            </div>

            <div className="w-full space-y-3 mb-6" data-id="element-297">
              <div className="flex items-center gap-3 text-gray-700" data-id="element-298">
                <BookOpen size={18} className="text-navy flex-shrink-0" data-id="element-299" />
                <span className="text-sm" data-id="element-300">
                  <strong data-id="element-301">The Main Archive:</strong> Voices of Freedom
                  (Biography & eBook)
                </span>
              </div>
              <div className="flex items-center gap-3 text-gray-700" data-id="element-302">
                <Headphones size={18} className="text-navy flex-shrink-0" data-id="element-303" />
                <span className="text-sm" data-id="element-304">
                  <strong data-id="element-305">FREE Gift:</strong> Voices of Freedom Narrated
                  Audiobook
                </span>
              </div>
              <div className="flex items-center gap-3 text-gray-700" data-id="element-306">
                <Gift size={18} className="text-patriot-red flex-shrink-0" data-id="element-307" />
                <span className="text-sm" data-id="element-308">
                  <strong data-id="element-309">The Heritage Timeline:</strong> Remembering Charlie
                  Kirk (Collector's Tribute)
                </span>
              </div>
              <div className="flex items-center gap-3 text-gray-700" data-id="element-310">
                <Gift size={18} className="text-patriot-red flex-shrink-0" data-id="element-311" />
                <span className="text-sm" data-id="element-312">
                  <strong data-id="element-313">The Patriot's Playbook:</strong> The Last Patriot
                  (Legacy Action Guide)
                </span>
              </div>
            </div>

            <div className="bg-yellow-50 border border-yellow-200 text-yellow-800 p-3 rounded-md mb-6 text-sm font-bold text-center w-full" data-id="element-314">
              Includes 2 FREE Collector Bonuses + Narrated Audiobook Gift!
            </div>

            <CTAButton className="text-lg py-4 px-6 shadow-lg" fullWidth data-id="element-315">
              GET INSTANT ACCESS NOW — $17
            </CTAButton>

            <div className="flex items-center justify-center gap-2 text-gray-400 text-xs mt-4" data-id="element-316">
              <Shield size={14} data-id="element-317" />
              <span data-id="element-318">Secure checkout · Instant delivery via email</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}